import React, {Component} from "react"
import PropTypes from 'prop-types';
import {validate} from "./validation";
import "../../style/forms.scss";
import { ValidationMessage } from "./validation-message";

export default class Input extends Component{

    constructor(props){
        super(props);
        this.state = {
            value: (typeof(this.props.value) === 'undefined' || this.props.value === null ? '':this.props.value)  ,
            validationResult: {isValid:true,rules:[]}
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(this.props.value !== nextProps.value){
            this.setState({value: nextProps.value})
        }
        if(typeof(nextProps.validation) !== "undefined" &&
            typeof(nextProps.validation.validationResult) !== "undefined" &&
            nextProps.validation.validationResult.isValid !== this.state.validationResult.isValid &&
            nextProps.validation.validationResult.rules !== this.state.validationResult.rules){
            this.setState({validationResult: nextProps.validation.validationResult})
        }
    }
    handleChange(event){
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.value;
        if(typeof(this.props.format) === "function"){
            value = this.props.format(value);
        }
        this.setState({value: value, validationResult: validationResult})
        if(typeof(this.props.handleChange) === "function"){
            this.props.handleChange({field: this.props.name, value: value, validationResult:validationResult});
        }
    }
    handleBlur(event){
        const { skipBlurValidationIfEmptyInputValue = false } = this.props;
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.value;
        if(typeof(this.props.validation) !== "undefined"){
            let validationRuleResults = validate(this.props.validation,value);
            for(let ruleIndex in validationRuleResults){
                validationResult.isValid = validationResult.isValid && validationRuleResults[ruleIndex].isValid
            }
            validationResult.rules = validationRuleResults;
        }
        !skipBlurValidationIfEmptyInputValue && this.setState({value: value, validationResult: validationResult});
        if(typeof(this.props.onBlur) === "function"){
            this.props.onBlur({field: this.props.name, value: value, validationResult:validationResult});
        }
    }


    render(){
        const handleOnFocus = typeof(this.props.onFocus) === "undefined" ? ()=>{} : this.props.onFocus ;
        let {inputType, ...rest} = this.props;
        let requiredClass = (this.props.validation && this.props.validation.isRequired) ? " required ":""
        let label = this.props.label + ((this.props.validation && this.props.showRequiredIndicator !== false && this.props.validation.required) ? "*":"")
        return (
            <div className={"form-field-group " + requiredClass + (!this.state.validationResult.isValid ? "validation-invalid ":"") + (this.props.readOnly === true ? " field-disabled ":"") + this.props.className}>
                <label className={"form-input-label hidden " + requiredClass}>{label}</label>
                <input  type={inputType === null ? 'text' : inputType}
                       className="form-text-input"
                       placeholder={this.props.placeholder? this.props.placeholder: label}
                       value={this.state.value}
                       maxLength={this.props.maxLength}
                       onBlur={this.handleBlur}
                       onChange={this.props.onChange ? this.props.onChange : this.handleChange}
                       onFocus={handleOnFocus}
                       name={this.props.name}
                       onKeyDown={this.props.onKeyDown}
                       onKeyPress={this.props.onKeyPress}
                       readOnly={this.props.readOnly === true}
                       ref={this.props.refCallback}
                />
                <ValidationMessage validationResult={this.state.validationResult}/>
                {this.props.afterElement ? this.props.afterElement : null}
            </div>
        )
    }
}

Input.propTypes = {
    inputType: PropTypes.oneOf(['text', 'password']),
    className: PropTypes.string,
    skipBlurValidationIfEmptyInputValue: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.any,
    onBlur: PropTypes.func,
    myonchange: PropTypes.func,
    readOnly: PropTypes.bool,
    onKeyPress: PropTypes.func,
    onKeyDown: PropTypes.func,
    refCallback: PropTypes.func,
    placeholder: PropTypes.string,
    handleChange: PropTypes.func,
    afterElement: PropTypes.element,
    showRequiredIndicator: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/common/components/forms/input.jsx